import React from 'react';
import { connect } from 'react-redux';
import { medicosCarga, hospitalesCarga, actualizaFlagMarcadores, municipiosPromise } from './directorio.act';

const ubicacionG = require("../img/localizaG.svg");
const ubicacionN = require("../img/localizaN.svg");
const esCliente = localStorage.getItem("esCliente") ? true: false;

const mapState = (state) => {
    return {
        loading: state.global.loading,
        servicio: state.directorio.servicios,
        filtrosM: state.directorio.medicos,
        filtrosH: state.directorio.hospitales,
        listaMedicos: state.directorio.listaMedicos,
        listaHospitales: state.directorio.listaHospitales,
        finalizo: state.directorio.finalizo,
        marcadoresFlag: state.directorio.marcadoresFlag,
        errorServidor: state.directorio.errorServidor
    };
}

const mapDispatch = (dispatch) => {
    return {
        guardaItemSeleccionado: (_item) => {
            dispatch({ "type": "DIRECTORIO_OPCIONAL", "opcional": _item})
        },
        cargaMedicos: (_idMunicipio, _idEstado, _idEspecialidad, _idCirculo, nombre, apaterno, amaterno) => {
            dispatch(medicosCarga(_idMunicipio, _idEstado, _idEspecialidad, _idCirculo, nombre, apaterno, amaterno));
        },
        cargaHospitales: (_idEstado, _idMunicipio, _idPlan) => {
            let tmpPlanValue = localStorage.getItem("planValue");
            let tmpIdPlan = ![undefined, null, '', "", "undefined", "0"].includes(tmpPlanValue) ? tmpPlanValue : _idPlan;
            dispatch(hospitalesCarga(_idEstado, _idMunicipio, tmpIdPlan));
        },
        cambiaFlagMarcadores: (_paso) => {
            dispatch(actualizaFlagMarcadores(_paso));
        }
    }
}

class Resultados extends React.Component {

    state = {
        activo : null,
        municipios : [],
        planesCliente: []
    }

    detalleMapa = (_item) => {
        this.setState({ "activo": _item });
        this.props.guardaItemSeleccionado(_item);
        this.props.cambiaFlagMarcadores(2);
    }

    componentWillMount = () => {

        var _this = this;

        window.scrollTo(0,0);

        municipiosPromise().then(snapshot => {
            _this.setState({"municipios" : snapshot.val()});
        });

        if(this.props.servicio == "medicos"){
            this.props.cargaMedicos(this.props.filtrosM.municipio, this.props.filtrosM.estado, this.props.filtrosM.especialidad, this.props.filtrosM.circulo, this.props.filtrosM.nombre, this.props.filtrosM.apaterno, this.props.filtrosM.amaterno);
        }

        if(this.props.servicio == "hospitales"){
            this.props.cargaHospitales(this.props.filtrosH.estado, this.props.filtrosH.municipio, this.props.filtrosH.plan);
        }

        let planesCliente = localStorage.getItem("planesCliente");
        let planesId = "";
        if(planesCliente) {
            planesCliente = planesCliente.replace("|", "");
            let planesClienteArray = planesCliente.split("|");
            let str = "";

            for(let a = 0; a < planesClienteArray.length; a++) {
                str = str + planesClienteArray[a] + ",";
            }
            str = str.substring(0, str.length - 1);
            let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
            planesC.planesClientes.map((p) => {
                planesId = planesId + "{\"nombre\":\"" + p.planComercial +"\", \"poliza\":\"" + p.numPoliza +"\"},";
            });
            planesId = planesId.substring(0, planesId.length - 1);
        }
        planesId = "[" + planesId + "]";
        _this.setState({"planesCliente": JSON.parse(planesId)});
    }

    transformarPlanes(idPlan) {
        let planVerdadero = idPlan;
        let planesSubplanesJSON = JSON.parse(localStorage.getItem("planesSubplanesGNP"));
        try {
            planesSubplanesJSON.map((psj) => {
                if(psj.idplan !== idPlan) {
                    let subplanes = psj.subplanes;
                    if(subplanes !== "") {
                        let subplanesArray = subplanes.split(",");
                        for(let i = 0; i < subplanesArray.length; i++) {
                            if(Number(subplanesArray[i]) === Number(idPlan)) {
                                planVerdadero = psj.idplan;
                                break;
                            }
                        }
                    }
                }
            });
        } catch(e) {
            console.log(e);
        }
        return planVerdadero;
    }

    validaHospital = (el) => {
        let planSeleccionado = parseInt(localStorage.getItem("planValue"));
        let valido = false;
        let planesCliente = localStorage.getItem("planesCliente").replace("|", "");
        let planesClienteArray = planesCliente.split("|");
        let str = "";
        for(let a = 0; a < planesClienteArray.length; a++) {
            str = str + planesClienteArray[a] + ",";
        }
        str = str.substring(0, str.length - 1);
        let planesC = JSON.parse("{\"planesClientes\": [" + str +  "]}");
	    planesC.planesClientes.map((p) => {
		let planes = el.planes.split(",");
		for(let a = 0; a < planes.length; a++) {
		    if(p.cvePlan > 22) {
		        if(Number(this.transformarPlanes(p.cvePlan)) === Number(planes[a]) || Number(p.cvePlan) === Number(planes[a])) {
		            valido = true;
		        }
		    } else {
		        if(Number(p.cvePlan) === Number(planes[a])) {
		            valido = true;
		        }
		    }
		}
	    });
        return valido;
    }

    verificaNull = (elemento) => {
        let elem = elemento;
        if(!elem){
            return "";
        }

        if(elem == "NULL"){
            return "";
        }

        return elem;
    }

    acentuar = () => {
        if(this.props.servicio == "medicos"){
            return "MÉDICOS EN CONVENIO";
        }

        if(this.props.servicio == "hospitales"){
            return "<div>" +
                "Mis polizas" +
                "</div>" +
                "Resultados de búsqueda";
        }
    }

    getMunicipio = (item) => {
        let municipio = this.state.municipios.filter(mItem => {
            if(mItem.idmunicipio == item.idmunicipio) return mItem;
        });

        if(municipio.length > 0) {
            return (", " + municipio[0].estado + ", " + municipio[0].nombre).toUpperCase();
        } else {            
            return "";
        }
    }

    render() {
        return (
            <div id="resultados" className="overflow-wrap">
                <hr style={{"marginTop":"5px","marginBottom":"10px"}} />
                {this.props.servicio == "hospitales" && this.state.planesCliente && this.state.planesCliente.length > 0 &&
                    <div className="mostrar" style={{"backgroundColor":"#ececec", "paddingBottom":"10px", "paddingTop":"10px"}}>
                        <p><img src={ubicacionN}/>  <b>Mis planes</b></p>
                        {
                            this.state.planesCliente.map((item, i) => {
                            return <p key={i} style={{"paddingLeft":"20px", "fontFamily":"Arial", "fontSize":"12", "fontWeight":"bold","color":"#333333"}}>{item.nombre} <span style={{"fontFamily":"Arial", "fontSize":"12px", "fontWeight":"normal", "color":"#687a8d"}}>No. p&oacute;liza: {item.poliza}</span></p>
                        })}
                    </div>

                }
                {this.props.servicio == "hospitales" &&
                    <div style={{"paddingTop":"20px", "paddingBottom":"20px"}}>
                        <p style={{"color":"#666666","fontWeight":"bold", "fontFamily":"Arial", "fontSize":"14px"}}>Resultados de b&uacute;squeda</p>
                    </div>
                }
                <ul>
                {this.props.errorServidor &&
                    <h3>No hay resultados</h3>
                }
                {this.props.servicio == "medicos" && !this.props.errorServidor && this.props.listaMedicos.length == 0 && this.props.finalizo &&
                    <h3>No hay resultados</h3>
                }
                { this.props.servicio == "medicos" && this.props.finalizo && !this.props.errorServidor && this.props.listaMedicos.map((item, i) => {
                            return <li key={i} className={(item == this.state.activo ? 'activo' : '')}>
                                <a onClick={this.detalleMapa.bind(this, item)}>
                                    <div className="descripcion">{item.apaterno} {item.amaterno}, {item.nombre}</div>
                                    <div className="direccion"><b>{item.direccion}, {item.colonia}, {item.cp}{this.getMunicipio(item)}</b></div>
                                    <div className="direccion">{item.nombre_especialidad}</div>
                                    <div className="direccion">{item.nombre_circulo}</div>
                                    <div className="telefono">{this.verificaNull(item.telefono)}</div>
                                    <div className="web">{this.verificaNull(item.correo)}</div>
                                </a>
                            </li>
                    })
                }

                {this.props.servicio == "hospitales" && !this.props.errorServidor && this.props.listaHospitales.length == 0 && this.props.finalizo &&
                    <h3>No hay resultados</h3>
                }
                {
                    this.props.servicio == "hospitales" && this.props.finalizo && !this.props.errorServidor && this.props.listaHospitales.map((item, i) => {
                            return <li key={i} className={(item == this.state.activo ? 'activo' : '')}>

                                            <a onClick={this.detalleMapa.bind(this, item)}>
                                                <div style={{"fontFamily":"Arial", "fontSize":"12", "fontWeight":"bold", "color":"#173d7b", "paddingBottom":"10px"}}>
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-sm-1 col-xs-1">
                                                                <img src={this.validaHospital(item) ? ubicacionN : ubicacionG} alt="ubicacionG"/>
                                                            </div>
                                                            <div className="col-sm-10 col-xs-10">
                                                                <span style={{textAlign:"justify"}}> {item.nombre}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="direccion" style={{"paddingLeft":"28px","fontFamily":"Arial", "fontSize":"12", "fontWeight":"bold", "color":"#333333"}}><b>{item.calle}, {item.colonia}, {item.cp}{this.getMunicipio(item)}</b></div>
                                                <div className="telefono" style={{"paddingLeft":"28px","fontFamily":"Arial", "fontSize":"12", "fontWeight":"bold", "color":"#333333"}}>{item.telefono}</div>
                                                <div className="web" style={{"paddingLeft":"28px","fontFamily":"Arial", "fontSize":"12", "fontWeight":"bold", "color":"#333333"}}>{item.pagina}</div>
                                            </a>

                            </li>;
                    })
                }
                </ul>
            </div>
        )
    }
}

export default connect(mapState, mapDispatch)(Resultados);



// WEBPACK FOOTER //
// ./src/directorio/resultados.cmpt.js